export default __webpack_public_path__ + "static/media/gallery_03.93c85368.jpg";